module.exports = __webpack_public_path__ + "media/images/icons/icon-x-close-c8c43d11cf8823c388abd43b381c4a1f.svg";